module.exports = __webpack_public_path__ + "img/s7.15a38723.svg";